import React from 'react';
import { Grid } from '@mui/material';

import { ModuleSearchField, SearchSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function CompaniesDetailsSectionSource(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			{/* PARENT COMPANY */}
			<Grid size={12}>
				<ModuleSearchField
					name="comp_parent_comp_uid"
					label={t('DETAILS_COMPANIES_FIELD_PARENT_COMPANY')}
					module="companies"
					filters={[
						{
							filt_field: 'comp_uid',
							filt_clause: 'not_equal',
							filt_value: props.model.comp_uid
						}
					]}
					uid={props.model.comp_parent_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					afterChange={newValue => {
						props.sendChange('comp_lech_id', newValue?.comp_lech_id);
						props.sendChange('comp_broker_comp_uid', newValue?.comp_broker_comp_uid);
					}}
					logProps={props.logProps}
				/>
			</Grid>
			{/* LEAD CHANNEL */}
			<Grid size={12}>
				<SearchSelectField
					name="comp_lech_id"
					label={t('DETAILS_COMPANIES_FIELD_LEADCHANNEL')}
					systable="leadchannels"
					value={props.model.comp_lech_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ORIGIN MARKETING ACTION */}
			<Grid size={12}>
				<ModuleSearchField
					name="comp_maac_uid"
					label={t('DETAILS_COMPANIES_FIELD_MARKETINGACTION')}
					module="marketingactions"
					uid={props.model.comp_maac_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					validations={{
						noDuplicatedCampaigns: (values, value) => {
							return !!values.comp_cmcp_uid && !!value?.maac_uid
								? t('ERROR_TEXT_NO_DUPLICATED_CAMPAIGNS')
								: true;
						}
					}}
				/>
			</Grid>
			{/* ORIGIN COMMERCIAL CAMPAIGN */}
			<Grid size={12}>
				<ModuleSearchField
					name="comp_cmcp_uid"
					label={t('DETAILS_COMPANIES_FIELD_COMMERCIALCAMPAIGN')}
					module="commercialcampaigns"
					uid={props.model.comp_cmcp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					validations={{
						noDuplicatedCampaigns: (values, value) => {
							return !!values.comp_maac_uid && !!value?.cmcp_uid
								? t('ERROR_TEXT_NO_DUPLICATED_CAMPAIGNS')
								: true;
						}
					}}
				/>
			</Grid>
			{/* BROKER COMPANY */}
			<Grid size={12}>
				<ModuleSearchField
					name="comp_broker_comp_uid"
					label={t('DETAILS_COMPANIES_FIELD_BROKER_COMPANY')}
					module="companies"
					filters={[
						{
							filt_field: 'comp_uid',
							filt_clause: 'not_equal',
							filt_value: props.model.comp_uid
						}
					]}
					uid={props.model.comp_broker_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* BROKER PEOPLE */}
			<Grid size={12}>
				<ModuleSearchField
					name="comp_broker_peop_uid"
					label={t('DETAILS_COMPANIES_FIELD_BROKER_PERSON')}
					module="people"
					filters={[
						{
							filt_field: 'peop_comp_uid',
							filt_clause: 'not_equal',
							filt_value: props.model.comp_uid
						}
					]}
					uid={props.model.comp_broker_peop_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
